import React, { useRef, useEffect } from 'react';
import { FocusRestorationContext } from '@atlassian/jira-navigation-apps-sidebar-nav4-projects-customise-order/src/controllers/focus-restoration-context.tsx';

export type DragAndDropProps = {
	menuItemAnchorRef?: React.RefObject<HTMLAnchorElement>;
	menuItemButtonRef?: React.RefObject<HTMLButtonElement>;
};

export type Nav4ProjectMenuItemContentProps = {
	renderMenuItem: (dragAndDropProps?: DragAndDropProps) => React.JSX.Element;
};

// The idea of this component is to provide a drag-and-drop context for the project menu items.
// The context will be read deep down the tree where the menuItem which supports drag-and-drop is rendered.

export function ContentWithDragAndDrop({ renderMenuItem }: Nav4ProjectMenuItemContentProps) {
	const menuItemButtonRef = useRef<HTMLButtonElement | null>(null);
	const menuItemAnchorRef = useRef<HTMLAnchorElement | null>(null);

	const shouldRestoreFocusRef = useRef<boolean>(false);

	useEffect(() => {
		if (shouldRestoreFocusRef.current) {
			// .focus() seems to be more reliable in the next task when used with VoiceOver
			setTimeout(() => {
				(menuItemButtonRef.current ?? menuItemAnchorRef.current)?.focus();
				shouldRestoreFocusRef.current = false;
			});
		}
	});

	return (
		<FocusRestorationContext.Provider value={{ shouldRestoreFocusRef }}>
			{renderMenuItem({
				menuItemAnchorRef,
				menuItemButtonRef,
			})}
		</FocusRestorationContext.Provider>
	);
}
